<template>
<div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
        <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-large rounded="sm">
            <b-card class="mb-0">
                <div v-if="loading" class="loading-logo-wrap">
                    <div class="loading-logo"></div>
                    <div class="loading-text">確認付款中...</div>
                </div>
                <div v-if="showTick" class="success-tick-wrap">
                    <div class="success-tick">✓</div>
                </div>
                <b-list-group>
                    <b-list-group-item><strong>付款狀態</strong>: {{ statusText }}</b-list-group-item>
                    <b-list-group-item><strong>付款編號</strong>: {{ orderNo || 'N/A' }}</b-list-group-item>
                    <b-list-group-item><strong>付款金額</strong>: HKD {{ transaction.amount || 'N/A' }}</b-list-group-item>
                    <b-list-group-item><strong>會員編號</strong>: {{ transaction.member_code || 'N/A' }}</b-list-group-item>
                    <!-- <b-list-group-item><strong>輪詢間隔</strong>: 3 秒</b-list-group-item> -->
                    <b-list-group-item><strong>最後更新</strong>: {{ lastCheckedAt || '等待中...' }}</b-list-group-item>
                </b-list-group>
                <div v-if="showTick" class="success-note">你可以關閉此視窗</div>
                
                <div class="text-center mt-2" style="font-size:10px;color:#888;">Powered by CloudFit Pro</div>
            </b-card>
        </b-overlay>
    </div>
</div>
</template>

<script>
import {
    BCard,
    BOverlay,
    BListGroup,
    BListGroupItem
} from 'bootstrap-vue'
import router from '@/router'

export default {
    components: {
        BCard,
        router,
        BOverlay,
        BListGroup,
        BListGroupItem,
    },

    data() {
        return {
            loading: true,
            statusText: '等待付款確認中...',
            pollTimer: null,
            orderNo: '',
            transaction: {},
            returnUrl: '',
            lastCheckedAt: '',
            showTick: false,
        }
    },
    created() {
        this.orderNo = router.currentRoute.params.order_no || ''
        this.payment_gateway = router.currentRoute.params.payment_gateway
        this.returnUrl = this.$route.query.return_url || ''
        this.get_transaction_detail()
        this.start_polling()
    },
    beforeDestroy() {
        this.stop_polling()
    },
    methods: {
        start_polling() {
            this.pollTimer = setInterval(() => {
                this.get_transaction_detail()
            }, 3000)
        },
        stop_polling() {
            if (this.pollTimer) {
                clearInterval(this.pollTimer)
                this.pollTimer = null
            }
        },
        get_transaction_detail() {
            this.$http.get(process.env.VUE_APP_API_BASE + `/payment_gateway/qfpay/status/${this.orderNo}/`)
                .then(res => {
                    this.lastCheckedAt = new Date().toLocaleString('zh-HK')
                    this.showTick = !!(res.data && res.data.result === true)

                    const hasReturn = !!(res.data && (res.data.return || res.data.return_url || res.data.result === true))
                    if (hasReturn) {
                        this.loading = false
                        this.stop_polling()
                        this.statusText = '付款成功'
                        this.transaction = res.data.transaction 
                        return
                    }

                    this.statusText = '等待付款確認中...'
                })
                .catch(() => {
                    this.loading = false
                    this.lastCheckedAt = new Date().toLocaleString('zh-HK')
                    this.statusText = '連線中，正在重試...'
                })
        },
    }
}
</script>
  
  
<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.loading-logo-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
}

.loading-logo {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    border: 4px solid #dbe6ff;
    border-top-color: #1e5bff;
    animation: spin 0.9s linear infinite;
}

.loading-text {
    margin-top: 8px;
    font-size: 13px;
    color: #4f5f7a;
}

.success-tick-wrap {
    display: flex;
    justify-content: center;
    margin-bottom: 12px;
}

.success-tick {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background: #eafaf1;
    color: #0f9d58;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 60px;
    font-weight: 700;
}

.success-note {
    margin-top: 10px;
    text-align: center;
    color: #0f9d58;
    font-weight: 600;
}

.payment_method_button{
    cursor: pointer;
    border: 2px solid #eee;
    border-radius: 10px;
    &:hover{
        border-color: #ccc;
    }
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
</style>

